export default __webpack_public_path__ + "static/media/starWars.ae84a077.jpg";